<template>
  <v-container class="mobile-form-container">
    <!-- Added smooth transitions between screens -->
    <transition name="slide-fade" mode="out-in">
      <div v-if="codeSent === false" key="phone-screen" class="form-content-mobile">
        <div class="text-center slide-in-up">
          <h1 class="welcome-title-mobile">ברוכים הבאים!</h1>
          <p class="welcome-subtitle-mobile">אנא הכניסו את מספר הפלאפון שלכם שאתו</p>
          <p class="welcome-subtitle-mobile">נרשמתם למערכת</p>
        </div>
        
        <v-form @submit.prevent="submitHandler" ref="form">
          <div class="input-wrapper-mobile slide-in-up" style="animation-delay: 0.1s;">
            <v-text-field 
              class="custom-text-field-mobile" 
              type="number" 
              hide-spin-buttons 
              hide-details 
              v-model="account_id"
              label="הקלד כאן" 
              solo 
              text
            ></v-text-field>
          </div>
        </v-form>

        <div class="button-wrapper-mobile slide-in-up" style="animation-delay: 0.2s;">
          <v-btn 
            @click="sendAuth" 
            class="gradiant-bt custom-button-mobile" 
            dark
            elevation="4"
            text
          >
            <span class="button-text-mobile">המשך</span>
          </v-btn>
        </div>
        
        <div class="alternative-login-mobile slide-in-up" style="animation-delay: 0.3s;" @click="$router.replace('/login-user')">
          <span class="alternative-text-mobile">או הכנסו באמצעות שם משתמש וסיסמה</span>
        </div>
      </div>

      <div v-else key="otp-screen" class="form-content-mobile">
        <div class="text-center slide-in-up">
          <h1 class="welcome-title-mobile">הכנס קוד אימות</h1>
        </div>
        
        <div class="sms-icon-wrapper-mobile slide-in-up" style="animation-delay: 0.1s;">
          <div class="icon-circle-mobile pulse">
            <img src="../../../assets/icon_sms.svg" class="sms-icon-mobile">
          </div>
        </div>
        
        <div class="text-center slide-in-up" style="animation-delay: 0.2s;">
          <p class="welcome-subtitle-mobile">ברגעים אלו ממש נשלח אליך sms</p>
          <p class="welcome-subtitle-mobile">אנא הכנס את קוד האימות שנשלח אליך</p>
        </div>
        
        <v-form @submit.prevent="submitHandler" ref="form">
          <div class="input-wrapper-mobile slide-in-up" style="animation-delay: 0.3s;">
            <v-text-field 
              v-model="smsCode" 
              ref="otpField" 
              label="הכנס קוד אימות" 
              class="custom-text-field-mobile" 
              outlined
              dense 
              type="number" 
              hide-spin-buttons 
              hide-details 
              solo 
              flat
              :rules="[v => !!v || 'שדה חובה']" 
              @keydown.enter="handleEnterKeyOtp"
            ></v-text-field>
          </div>
        </v-form>
        
        <div class="resend-wrapper-mobile slide-in-up" style="animation-delay: 0.4s;">
          <span @click="resend" class="resend-text-mobile">לא קיבלתי, נא לשלוח שוב</span>
        </div>
        
        <div class="button-wrapper-mobile slide-in-up" style="animation-delay: 0.5s;">
          <v-btn 
            @click="smsVerify" 
            dark 
            rounded 
            class="gradiant-bt custom-button-mobile"
            elevation="4"
          >
            <span class="button-text-mobile">המשך</span>
          </v-btn>
        </div>
      </div>
    </transition>

    <v-row v-if="progressShow" class="progress-row-mobile">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="white" size="50"></v-progress-circular>
      </v-col>
    </v-row>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {

  components: {
    SnackBar
  },

  data: () => ({
    isResponsive: false,
    account_id: "",
    verifyCode: "",
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    codeSent: false,
    smsCode: "",
  }),
  methods: {

    async loginByPhone() {
      if (this.$refs.form.validate()) {

        this.progressShow = true
        let MyJSON = JSON.stringify({ account_id: this.account_id });
        let api = process.env.VUE_APP_BASE_URL + "/auth/login"

        try {
          const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
          this.progressShow = false;
          const jsonObject = await response.json();
          if (response.status >= 400) {
            this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
          } else if (response.status === 200) {
            this.showSnackBar("הזיהוי עבר בהצלחה, נשלח סמס לאימות", "green");
            localStorage.setItem("accountId", this.account_id)
            this.codeSent = true;
            this.$emit("removeRobot");
          }
        } catch (error) {
          this.showSnackBar("Error Login: " + error, "red");
        }

      }
    },
    async smsVerify() {
      if (this.$refs.form.validate()) {

        this.progressShow = true
        const accountId = localStorage.getItem("accountId");
        let MyJSON = JSON.stringify({ account_id: accountId, smsCode: this.smsCode });
        let api = process.env.VUE_APP_BASE_URL + "/auth/verify_code"

        try {
          const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
          this.progressShow = false;
          const jsonObject = await response.json();
          if (response.status >= 400) {
            this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
          } else if (response.status === 200) {
            this.showSnackBar("התחברת בהצלחה!", "green");
            localStorage.setItem('token', jsonObject.token);
            this.$router.replace({ name: "callHistory" })
          }
        } catch (error) {
          this.showSnackBar("Error Login: " + error, "red");
        }

      }
    },
    sendAuth() {
      this.loginByPhone();
    },
    async resend() {

      this.progressShow = true
      const accountId = localStorage.getItem("accountId");
      let MyJSON = JSON.stringify({ account_id: accountId });
      let api = process.env.VUE_APP_BASE_URL + "/auth/login"

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
        this.progressShow = false;
        if (response.status >= 400) {
          this.showSnackBar("שגיאה בשליחת סמס", "red");
        } else if (response.status === 200) {
          this.showSnackBar("סמס נשלח בהצלחה!", "green");
        }
      } catch (error) {
        this.showSnackBar("Error Login: " + error, "red");
      }

    },
    handleEnterKeyOtp(event) {
      if (event.keyCode === 13) {
        this.smsVerify();
      }
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    async startListeningToOtp() {
      if ('OTPCredential' in window) {
        try {
          const content = await navigator.credentials.get({
            otp: { transport: ['sms'] },
            signal: this.abortController.signal,
          });
          if (content) {
            this.smsCode = content.code;
            setTimeout(() => {
              this.smsVerify();
            }, 700);
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    beforeDestroy() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }
  },
  watch: {
    $route() {
      document.title = 'Login Phone | CLICK-CALL'
    },
  },
  mounted() {
    this.startListeningToOtp();
  },
  created() {
    this.abortController = new AbortController();
  }

}
</script>
<style scoped>
/* Mobile-optimized container with glassmorphism effect */
.mobile-form-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 30px 20px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent);
  backdrop-filter: blur(10px);
  border-radius: 30px 30px 0 0;
}

.mobile-form-container.otp-screen {
  top: 20%;
  bottom: auto;
}

.form-content-mobile {
  width: 100%;
}

/* Enhanced mobile typography */
.welcome-title-mobile {
  color: white;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 12px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.welcome-subtitle-mobile {
  color: white;
  font-size: 15px;
  margin: 4px 0;
  opacity: 0.95;
  line-height: 1.6;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

/* Mobile input styling with enhanced effects */
.input-wrapper-mobile {
  margin-top: 24px;
  width: 100%;
}

.custom-text-field-mobile >>> .v-input__control .v-input__slot {
  background-color: white;
  border-radius: 20px;
  border: 2px solid #0052cc;
  padding: 8px 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 82, 204, 0.15);
}

.custom-text-field-mobile >>> .v-input__control .v-input__slot:focus-within {
  border-color: #0066ff;
  box-shadow: 0 0 0 4px rgba(0, 82, 204, 0.2);
  transform: scale(1.02);
}

/* Mobile button with enhanced interactions */
.button-wrapper-mobile {
  margin-top: 20px;
  width: 100%;
}

.custom-button-mobile {
  width: 100%;
  border-radius: 20px;
  padding: 20px 16px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.custom-button-mobile::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.custom-button-mobile:active::before {
  width: 300px;
  height: 300px;
}

.custom-button-mobile:active {
  transform: scale(0.98);
}

.button-text-mobile {
  font-weight: bold;
  font-size: 17px;
  position: relative;
  z-index: 1;
}

.gradiant-bt {
  background: linear-gradient(94deg, rgba(140, 159, 245, 1) 1%, rgba(9, 104, 224, 1) 70%);
}

/* Mobile SMS icon with pulse animation */
.sms-icon-wrapper-mobile {
  text-align: center;
  margin: 25px 0;
}

.icon-circle-mobile {
  display: inline-block;
  background-color: aliceblue;
  padding: 20px;
  border-radius: 50%;
  box-shadow: 0 8px 24px rgba(0, 82, 204, 0.2);
}

.sms-icon-mobile {
  width: 50px;
  height: 50px;
  display: block;
}

.pulse {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 8px 24px rgba(0, 82, 204, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 12px 32px rgba(0, 82, 204, 0.35);
  }
}

/* Mobile alternative login styling */
.alternative-login-mobile {
  margin-top: 24px;
  cursor: pointer;
  text-align: center;
  padding: 10px;
}

.alternative-text-mobile {
  color: white;
  font-size: 14px;
  text-decoration: underline;
  opacity: 0.9;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

/* Mobile resend link */
.resend-wrapper-mobile {
  text-align: center;
  margin-top: 14px;
  padding: 8px;
}

.resend-text-mobile {
  color: white;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  opacity: 0.9;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

/* Mobile progress indicator */
.progress-row-mobile {
  margin-top: 16px;
}

/* Slide-in-up animation */
.slide-in-up {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Screen transition effects */
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter {
  transform: translateY(30px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

/* Responsive adjustments for different mobile sizes */
@media (max-width: 400px) {
  .mobile-form-container {
    padding: 25px 15px;
  }
  
  .welcome-title-mobile {
    font-size: 24px;
  }
  
  .welcome-subtitle-mobile {
    font-size: 13px;
  }
  
  .button-text-mobile {
    font-size: 15px;
  }
  
  .sms-icon-mobile {
    width: 45px;
    height: 45px;
  }
}

@media (min-width: 600px) and (max-width: 1000px) {
  .mobile-form-container {
    max-width: 500px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .welcome-title-mobile {
    font-size: 32px;
  }
  
  .welcome-subtitle-mobile {
    font-size: 16px;
  }
}

@media (max-height: 700px) {
  .mobile-form-container {
    padding: 20px 15px;
  }
  
  .input-wrapper-mobile {
    margin-top: 18px;
  }
  
  .button-wrapper-mobile {
    margin-top: 16px;
  }
  
  .alternative-login-mobile {
    margin-top: 18px;
  }
}
</style>
